import { Chip, styled } from '@mui/material';

export const STATUS_CHIP_FONT_SIZE_PX = 14;
export const STATUS_CHIP_FONT_WEIGHT = 500;
export const STATUS_CHIP_FONT_FAMILY = 'Neue Frutiger World';
export const STATUS_CHIP_PADDING_X_PX = 12;

const ROOT_FONT_SIZE_PX = 16;

export const StyledStatusChip = styled(Chip)<{ statuscolor?: string; statusbg?: string }>(
  ({ statuscolor, statusbg }) => ({
    padding: `0.25rem ${STATUS_CHIP_PADDING_X_PX / ROOT_FONT_SIZE_PX}rem !important`,
    height: 'auto',
    borderRadius: '0.75rem',
    backgroundColor: statusbg || '#8F8EA3',
    color: statuscolor || '#FEFEFE',
    border: 'none',
    justifyContent: 'center',

    '& .MuiChip-label': {
      fontFamily: `${STATUS_CHIP_FONT_FAMILY} !important`,
      fontSize: `${STATUS_CHIP_FONT_SIZE_PX / ROOT_FONT_SIZE_PX}rem !important`,
      fontStyle: 'normal !important',
      fontWeight: `${STATUS_CHIP_FONT_WEIGHT} !important`,
      lineHeight: '130% !important',
      textTransform: 'capitalize !important',
      color: `${statuscolor || '#FEFEFE'} !important`,
      padding: '0 !important',
    },
  }),
);
